import React from 'react';
import Icon from 'antd/lib/icon';

const Feedback = props => (
    <div style={{
        padding: 40,
        width: '90%',
        display: 'inline-block',
        marginBottom: 100,
    }}>
        <Icon type={props.icon} style={{fontSize: 50}}/>
        <br/>
        <h3>{props.note}</h3>
    </div>
);

export default Feedback;



// WEBPACK FOOTER //
// ./src/components/UI/Feedback.jsx